// src/App.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { PermissionsProvider } from "./context/PermissionsContext"
import PrivateRoute from "./utils/PrivateRoute";
import { ROLES } from "./utils/roles";
import PublicOnlyRoute from "./utils/PublicOnlyRoute";
import Homepage from "./views/Homepage";
import Loginpage from "./views/Loginpage";
import RegisterPage from "./views/RegisterPage";

import AboutPage from "./views/AboutPage";
import PrivacyPage from "./views/PrivacyPage";
import TermsPage from "./views/TermsPage";
import Contact from "./views/Contact";
import Demo from "./views/Demo";
import Features from "./views/Features";
import HelpCenterPage from "./views/HelpCenterPage";
import AppsPage from "./views/AppsPage";

import PublicMaintenanceGate from "./views/PublicMaintenanceGate";
import ResetPasswordPage from "./views/ResetPasswordPage";
import ForgotPasswordPage from "./views/ForgotPasswordPage";
import VerifierRecu from "./views/public/VerifierRecu";

import SuperAdminLayout from "./views/superadmin/SuperAdminLayout";
import AdminLayout from "./views/admin/AdminLayout";
import EnseignantLayout from "./views/enseignant/EnseignantLayout";
import ParentLayout from "./views/parent/ParentLayout";




function App() {
  return (
    <Router>
      <AuthProvider>
        <PermissionsProvider>
        <Routes>
          {/* Routes publiques — bloquées par la page de maintenance si mode_maintenance est actif */}
<Route path="/" element={<PublicOnlyRoute><PublicMaintenanceGate><Homepage /></PublicMaintenanceGate></PublicOnlyRoute>} />

          
          <Route path="/about" element={<PublicMaintenanceGate><AboutPage /></PublicMaintenanceGate>} />
          <Route path="/privacy" element={<PublicMaintenanceGate><PrivacyPage /></PublicMaintenanceGate>} />
          <Route path="/terms" element={<PublicMaintenanceGate><TermsPage /></PublicMaintenanceGate>} />
          <Route path="/contact" element={<PublicMaintenanceGate><Contact /></PublicMaintenanceGate>} />
          <Route path="/demo" element={<PublicMaintenanceGate><Demo /></PublicMaintenanceGate>} />
          <Route path="/features" element={<PublicMaintenanceGate><Features /></PublicMaintenanceGate>} />
          <Route path="/help" element={<PublicMaintenanceGate><HelpCenterPage /></PublicMaintenanceGate>} />
          <Route path="/apps" element={<PublicMaintenanceGate><AppsPage /></PublicMaintenanceGate>} />
          
<Route path="/:slug/reset-password/:userId/:token" element={<ResetPasswordPage />} />
<Route path="/:slug/verifier-recu/:uuid" element={<VerifierRecu />} />
          {/* Login/Register jamais bloqués — sinon plus personne (surtout l'admin) ne peut se reconnecter */}

<Route path="/login" element={<PublicOnlyRoute><Loginpage /></PublicOnlyRoute>} />
<Route path="/register" element={<PublicOnlyRoute><RegisterPage /></PublicOnlyRoute>} />
<Route path="/mot-de-passe-oublier" element={<PublicOnlyRoute><ForgotPasswordPage /></PublicOnlyRoute>} />
          {/* Super Admin : niveau plateforme, aucun établissement précis */}
          <Route
            path="/super-admin/*"
            element={
              <PrivateRoute roles={[ROLES.SUPER_ADMIN]}>
                <SuperAdminLayout />
              </PrivateRoute>
            }
          />

          {/* ✅ Admin - avec slug dans l'URL */}
          <Route
            path="/:slug/admin/*"
            element={
              <PrivateRoute roles={[ROLES.ADMINISTRATEUR]}>
                <AdminLayout />
              </PrivateRoute>
            }
          />

          {/* ✅ Enseignant - avec slug dans l'URL */}
          <Route
            path="/:slug/enseignant/*"
            element={
              <PrivateRoute roles={[ROLES.ENSEIGNANT]}>
                <EnseignantLayout />
              </PrivateRoute>
            }
          />

          {/* ✅ Parent - avec slug dans l'URL */}
          <Route
            path="/:slug/parent/*"
            element={
              <PrivateRoute roles={[ROLES.PARENT]}>
                <ParentLayout />
              </PrivateRoute>
            }
          />

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
          </PermissionsProvider>

      </AuthProvider>
    </Router>
  );
}

export default App;